<template>
  <div class="customer-add">
    <van-nav-bar title="新增客户" left-text="返回" left-arrow @click-left="$router.back()"/>

    <div class="form-body">
      <van-cell-group>
        <van-field v-model="form.name" label="客户名称" placeholder="请输入客户名称" required clearable/>

        <van-field
          v-model="categoryLabel"
          label="客户分类"
          placeholder="请选择客户分类"
          readonly
          clickable
          @click="openPicker('category')"
        />

        <van-field
          v-model="ownerLabel"
          label="对接销售"
          placeholder="请选择对接销售"
          readonly
          clickable
          @click="openPicker('owner')"
        />

        <van-field v-model="form.contacts" label="联系人" placeholder="请输入联系人姓名" clearable/>
        <van-field v-model="form.mobile" label="手机" placeholder="请输入手机号" type="tel" clearable/>

        <van-field
          v-model="industryLabel"
          label="所属项目"
          placeholder="请选择所属项目"
          readonly
          clickable
          @click="openPicker('industry')"
        />

        <van-field
          v-model="needLabel"
          label="客户需求"
          :placeholder="form.industryId ? '请选择客户需求' : '请先选择所属项目'"
          readonly
          clickable
          @click="openPicker('need')"
        />

        <div class="area-row">
          <van-field
            v-model="provinceLabel"
            label="所属城市"
            placeholder="省"
            readonly
            clickable
            @click="openAreaPicker('province')"
          />
          <van-field
            v-model="cityLabel"
            placeholder="市"
            readonly
            clickable
            @click="openAreaPicker('city')"
          />
          <van-field
            v-model="districtLabel"
            placeholder="区/县"
            readonly
            clickable
            @click="openAreaPicker('district')"
          />
        </div>

        <van-field v-model="form.detailAddress" label="详细地址" placeholder="请输入详细地址" clearable/>

        <van-cell title="成交状态">
          <van-radio-group v-model="form.dealStatus" direction="horizontal">
            <van-radio :name="0">未成交</van-radio>
            <van-radio :name="1">已成交</van-radio>
          </van-radio-group>
        </van-cell>

        <van-field v-model="form.dealMoney" label="成交金额" placeholder="请输入成交金额（万元）" type="number" clearable/>
        <van-field v-model="form.expectedPaymentTime" label="预计回款日期" placeholder="请选择日期" type="date"/>
        <van-field v-model="form.remark" label="备注" placeholder="请输入备注" type="textarea" rows="2" clearable/>
      </van-cell-group>

      <div class="submit-bar">
        <van-button type="primary" block round :loading="saving" @click="submit">保存</van-button>
      </div>
    </div>

    <!-- 通用单选弹窗 -->
    <van-popup v-model="pickerVisible" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="pickerColumns"
        value-key="label"
        :title="pickerTitle"
        @confirm="onPickerConfirm"
        @cancel="pickerVisible = false"
      />
    </van-popup>

    <!-- 城市级联弹窗 -->
    <van-popup v-model="areaPickerVisible" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="areaPickerColumns"
        value-key="name"
        :title="areaPickerTitle"
        @confirm="onAreaConfirm"
        @cancel="areaPickerVisible = false"
      />
    </van-popup>
  </div>
</template>

<script>
import coreapi from "@/utils/coreapi";

// 国家省市区（前端内置），可按需扩展。结构：[{ name, code, children:[{ name, code, children:[...] }] }]
const CITY_DATA = [
  {
    name: "北京市", code: "110000", children: [
      {
        name: "北京市", code: "110100", children: [
          {name: "东城区", code: "110101"}, {name: "西城区", code: "110102"},
          {name: "朝阳区", code: "110105"}, {name: "丰台区", code: "110106"},
          {name: "石景山区", code: "110107"}, {name: "海淀区", code: "110108"},
          {name: "通州区", code: "110112"}, {name: "昌平区", code: "110114"}
        ]
      }
    ]
  },
  {
    name: "上海市", code: "310000", children: [
      {
        name: "上海市", code: "310100", children: [
          {name: "黄浦区", code: "310101"}, {name: "徐汇区", code: "310104"},
          {name: "长宁区", code: "310105"}, {name: "静安区", code: "310106"},
          {name: "普陀区", code: "310107"}, {name: "浦东新区", code: "310115"}
        ]
      }
    ]
  },
  {
    name: "广东省", code: "440000", children: [
      {
        name: "广州市", code: "440100", children: [
          {name: "荔湾区", code: "440103"}, {name: "越秀区", code: "440104"},
          {name: "海珠区", code: "440105"}, {name: "天河区", code: "440106"},
          {name: "白云区", code: "440111"}, {name: "番禺区", code: "440113"}
        ]
      },
      {
        name: "深圳市", code: "440300", children: [
          {name: "罗湖区", code: "440303"}, {name: "福田区", code: "440304"},
          {name: "南山区", code: "440305"}, {name: "宝安区", code: "440306"},
          {name: "龙岗区", code: "440307"}, {name: "龙华区", code: "440309"}
        ]
      },
      {
        name: "珠海市", code: "440400", children: [
          {name: "香洲区", code: "440402"}, {name: "斗门区", code: "440403"},
          {name: "金湾区", code: "440404"}
        ]
      }
    ]
  },
  {
    name: "浙江省", code: "330000", children: [
      {
        name: "杭州市", code: "330100", children: [
          {name: "上城区", code: "330102"}, {name: "拱墅区", code: "330105"},
          {name: "西湖区", code: "330106"}, {name: "滨江区", code: "330108"},
          {name: "萧山区", code: "330109"}, {name: "余杭区", code: "330110"}
        ]
      },
      {
        name: "宁波市", code: "330200", children: [
          {name: "海曙区", code: "330203"}, {name: "江北区", code: "330205"},
          {name: "镇海区", code: "330211"}, {name: "北仑区", code: "330206"},
          {name: "鄞州区", code: "330212"}
        ]
      }
    ]
  },
  {
    name: "江苏省", code: "320000", children: [
      {
        name: "南京市", code: "320100", children: [
          {name: "玄武区", code: "320102"}, {name: "秦淮区", code: "320104"},
          {name: "建邺区", code: "320105"}, {name: "鼓楼区", code: "320106"},
          {name: "江宁区", code: "320115"}
        ]
      },
      {
        name: "苏州市", code: "320500", children: [
          {name: "虎丘区", code: "320505"}, {name: "吴中区", code: "320506"},
          {name: "相城区", code: "320507"}, {name: "姑苏区", code: "320508"},
          {name: "工业园区", code: "320571"}
        ]
      }
    ]
  },
  {
    name: "四川省", code: "510000", children: [
      {
        name: "成都市", code: "510100", children: [
          {name: "锦江区", code: "510104"}, {name: "青羊区", code: "510105"},
          {name: "金牛区", code: "510106"}, {name: "武侯区", code: "510107"},
          {name: "成华区", code: "510108"}, {name: "高新区", code: "510112"}
        ]
      }
    ]
  },
  {
    name: "湖北省", code: "420000", children: [
      {
        name: "武汉市", code: "420100", children: [
          {name: "江岸区", code: "420102"}, {name: "江汉区", code: "420103"},
          {name: "硚口区", code: "420104"}, {name: "汉阳区", code: "420105"},
          {name: "武昌区", code: "420106"}, {name: "洪山区", code: "420111"}
        ]
      }
    ]
  }
];

// 客户需求选项：随所属项目（行业）变化
const CUSTOMER_NEED_OPTIONS = {
  "健康": ["小房型", "大房型", "理疗", "心理"],
  "安全": ["城市代理", "网红招募", "渠道"],
  "传媒": ["城市代理", "主任委员", "会员招募", "渠道"]
};

export default {
  name: "CustomerAdd",
  data() {
    return {
      form: {
        name: "",
        categoryId: "",
        ownerId: "",
        contacts: "",
        mobile: "",
        industryId: "",
        customerNeed: "",
        areaId: "",
        detailAddress: "",
        dealStatus: 0,
        dealMoney: "",
        expectedPaymentTime: "",
        remark: ""
      },
      categories: [],
      industries: [],
      owners: [],
      provinces: CITY_DATA,
      cities: [],
      districts: [],
      provinceName: "",
      cityName: "",
      districtName: "",
      pickerVisible: false,
      pickerType: "",
      pickerColumns: [],
      pickerTitle: "",
      areaPickerVisible: false,
      areaPickerType: "",
      areaPickerColumns: [],
      areaPickerTitle: "",
      saving: false
    };
  },
  computed: {
    categoryLabel() {
      const c = this.categories.find(x => String(x.value) === String(this.form.categoryId));
      return c ? c.label : "";
    },
    ownerList() {
      // owners 为按部门分组的结构 [{dept, users}]，这里展平为扁平列表
      const groups = this.owners || [];
      const list = [];
      groups.forEach(g => (g.users || []).forEach(u => list.push(u)));
      return list;
    },
    ownerLabel() {
      const o = this.ownerList.find(x => String(x.id) === String(this.form.ownerId));
      return o ? o.name : "";
    },
    industryLabel() {
      const i = this.industries.find(x => String(x.value) === String(this.form.industryId));
      return i ? i.label : "";
    },
    needLabel() {
      return this.form.customerNeed || "";
    },
    provinceLabel() {
      return this.provinceName;
    },
    cityLabel() {
      return this.cityName;
    },
    districtLabel() {
      return this.districtName;
    }
  },
  async mounted() {
    try {
      this.categories = await coreapi.bossCustomerDict("crm_customer_category1");
      this.industries = await coreapi.bossCustomerDict("crm_customer_industry");
      this.owners = await coreapi.bossOwners();
      // 默认当前登录人为对接销售：负责人下拉 id 即 system_users.id（= CrmUserId 体系），
      // 因此按 CrmUserId 匹配当前登录人；匹配不到再回退列表第一个
      const meCrm = localStorage.getItem("CrmUserId");
      const owner = meCrm != null && this.ownerList.find(o => String(o.id) === String(meCrm));
      if (owner) {
        this.form.ownerId = owner.id;
      } else if (this.ownerList.length) {
        this.form.ownerId = this.ownerList[0].id;
      }
    } catch (e) {
      this.$toast.fail("加载下拉数据失败");
      console.error(e);
    }
  },
  methods: {
    openPicker(type) {
      this.pickerType = type;
      if (type === "category") {
        this.pickerColumns = this.categories;
        this.pickerTitle = "选择客户分类";
      } else if (type === "owner") {
        this.pickerColumns = this.ownerList.map(o => ({...o, label: o.dept ? o.name + "（" + o.dept + "）" : o.name}));
        this.pickerTitle = "选择对接销售";
      } else if (type === "industry") {
        this.pickerColumns = this.industries;
        this.pickerTitle = "选择所属项目";
      } else if (type === "need") {
        if (!this.form.industryId) {
          this.$toast("请先选择所属项目");
          return;
        }
        const opts = CUSTOMER_NEED_OPTIONS[this.industryLabel] || [];
        if (opts.length === 0) {
          this.$toast("该项目暂无可选项");
          return;
        }
        this.pickerColumns = opts.map(o => ({label: o, value: o}));
        this.pickerTitle = "选择客户需求";
      }
      this.pickerVisible = true;
    },
    onPickerConfirm(value) {
      if (this.pickerType === "category") {
        this.form.categoryId = value.value;
      } else if (this.pickerType === "owner") {
        this.form.ownerId = value.id;
      } else if (this.pickerType === "industry") {
        this.form.industryId = value.value;
        // 所属项目变化后，原客户需求可能不再适用，清空重选
        this.form.customerNeed = "";
      } else if (this.pickerType === "need") {
        this.form.customerNeed = value.value;
      }
      this.pickerVisible = false;
    },
    openAreaPicker(type) {
      this.areaPickerType = type;
      if (type === "province") {
        this.areaPickerColumns = this.provinces;
        this.areaPickerTitle = "选择省份";
      } else if (type === "city") {
        if (!this.provinceName) {
          this.$toast("请先选择省份");
          return;
        }
        this.areaPickerColumns = this.cities;
        this.areaPickerTitle = "选择城市";
      } else if (type === "district") {
        if (!this.cityName) {
          this.$toast("请先选择城市");
          return;
        }
        this.areaPickerColumns = this.districts;
        this.areaPickerTitle = "选择区/县";
      }
      this.areaPickerVisible = true;
    },
    onAreaConfirm(value) {
      if (this.areaPickerType === "province") {
        this.provinceName = value.name;
        const p = this.provinces.find(x => x.name === value.name);
        this.cities = p && p.children ? p.children : [];
        this.cityName = "";
        this.districtName = "";
        this.districts = [];
        this.form.areaId = "";
      } else if (this.areaPickerType === "city") {
        this.cityName = value.name;
        const c = this.cities.find(x => x.name === value.name);
        this.districts = c && c.children ? c.children : [];
        this.districtName = "";
        this.form.areaId = "";
      } else if (this.areaPickerType === "district") {
        this.districtName = value.name;
        this.form.areaId = value.code || "";
      }
      this.areaPickerVisible = false;
    },
    validate() {
      if (!this.form.name.trim()) return "客户名称不能为空";
      if (!this.form.categoryId) return "请选择客户分类";
      if (!this.form.industryId) return "请选择所属项目";
      return null;
    },
    async submit() {
      const err = this.validate();
      if (err) {
        this.$toast(err);
        return;
      }
      this.saving = true;
      try {
        // 添加人 = 当前登录用户；对接销售 = 表单选中的 ownerId
        const adder = localStorage.getItem("CrmUserId") || localStorage.getItem("UserSysno");
        const payload = {
          name: this.form.name.trim(),
          contacts: this.form.contacts,
          mobile: this.form.mobile,
          categoryId: this.form.categoryId,
          industryId: this.form.industryId,
          areaId: this.form.areaId,
          detailAddress: this.form.detailAddress,
          dealStatus: this.form.dealStatus,
          dealMoney: this.form.dealMoney,
          expectedPaymentTime: this.form.expectedPaymentTime,
          customerNeed: this.form.customerNeed,
          remark: this.form.remark,
          creator: adder || 0,
          owner_user_id: this.form.ownerId
        };
        await coreapi.addBossCustomer(payload);
        this.$toast.success("保存成功");
        const back = this.$route.query.from === "list" ? "/boss/customer-list" : "/boss/customer-data";
        this.$router.replace({path: back, query: {type: this.$route.query.type}});
      } catch (e) {
        this.$toast.fail(e.message || "保存失败");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.customer-add {
  min-height: 100vh;
  background: #f5f5f5;
}

.form-body {
  padding-bottom: 24px;
}

.area-row {
  display: flex;
}

.area-row .van-field {
  flex: 1;
}

.area-row .van-field:first-child {
  flex: 1.2;
}

.submit-bar {
  padding: 16px 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/boss/CustomerAdd.vue